/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as PublicLoginRouteImport } from './routes/_public.login'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public.forgot-password'

const AuthUserProfileLazyRouteImport = createFileRoute('/_auth/user-profile')()
const AuthChangePasswordLazyRouteImport = createFileRoute(
  '/_auth/change-password',
)()
const AuthVideoIndexLazyRouteImport = createFileRoute('/_auth/video/')()
const AuthUsersIndexLazyRouteImport = createFileRoute('/_auth/users/')()
const AuthTestsIndexLazyRouteImport = createFileRoute('/_auth/tests/')()
const AuthScheduleIndexLazyRouteImport = createFileRoute('/_auth/schedule/')()
const AuthLeaguesIndexLazyRouteImport = createFileRoute('/_auth/leagues/')()
const AuthInvoicesIndexLazyRouteImport = createFileRoute('/_auth/invoices/')()
const AuthInternalReviewsIndexLazyRouteImport = createFileRoute(
  '/_auth/internal-reviews/',
)()
const AuthIdentityCardsIndexLazyRouteImport = createFileRoute(
  '/_auth/identity-cards/',
)()
const AuthDocumentsIndexLazyRouteImport = createFileRoute('/_auth/documents/')()
const AuthBalanceIndexLazyRouteImport = createFileRoute('/_auth/balance/')()
const AuthAvailabilityIndexLazyRouteImport = createFileRoute(
  '/_auth/availability/',
)()
const AuthVideoVideoGroupIdLazyRouteImport = createFileRoute(
  '/_auth/video/$videoGroupId',
)()
const AuthUsersNewLazyRouteImport = createFileRoute('/_auth/users/new')()
const AuthUsersImportLazyRouteImport = createFileRoute('/_auth/users/import')()
const AuthUsersUserIdLazyRouteImport = createFileRoute('/_auth/users/$userId')()
const AuthTestsNewLazyRouteImport = createFileRoute('/_auth/tests/new')()
const AuthScheduleMyLazyRouteImport = createFileRoute('/_auth/schedule/my')()
const AuthScheduleFullLazyRouteImport = createFileRoute(
  '/_auth/schedule/full',
)()
const AuthScheduleExportLazyRouteImport = createFileRoute(
  '/_auth/schedule/export',
)()
const AuthRefereeEvaluationStatisticsLazyRouteImport = createFileRoute(
  '/_auth/referee-evaluation/statistics',
)()
const AuthPostsNewLazyRouteImport = createFileRoute('/_auth/posts/new')()
const AuthLeaguesNewLazyRouteImport = createFileRoute('/_auth/leagues/new')()
const AuthLeaguesLeagueIdLazyRouteImport = createFileRoute(
  '/_auth/leagues/$leagueId',
)()
const AuthJournalUsersRankingLazyRouteImport = createFileRoute(
  '/_auth/journal/users-ranking',
)()
const AuthJournalRankingLazyRouteImport = createFileRoute(
  '/_auth/journal/ranking',
)()
const AuthJournalMyLazyRouteImport = createFileRoute('/_auth/journal/my')()
const AuthJournalExportLazyRouteImport = createFileRoute(
  '/_auth/journal/export',
)()
const AuthJournalExpensesLazyRouteImport = createFileRoute(
  '/_auth/journal/expenses',
)()
const AuthJournalBalanceLazyRouteImport = createFileRoute(
  '/_auth/journal/balance',
)()
const AuthInvoicesNewLazyRouteImport = createFileRoute('/_auth/invoices/new')()
const AuthInternalVideosNewLazyRouteImport = createFileRoute(
  '/_auth/internal-videos/new',
)()
const AuthInternalVideosMyLazyRouteImport = createFileRoute(
  '/_auth/internal-videos/my',
)()
const AuthInternalVideosAllLazyRouteImport = createFileRoute(
  '/_auth/internal-videos/all',
)()
const AuthInternalReviewsNewLazyRouteImport = createFileRoute(
  '/_auth/internal-reviews/new',
)()
const AuthInternalReviewsReviewIdLazyRouteImport = createFileRoute(
  '/_auth/internal-reviews/$reviewId',
)()
const AuthInternalDocumentsNewLazyRouteImport = createFileRoute(
  '/_auth/internal-documents/new',
)()
const AuthInternalDocumentsMyLazyRouteImport = createFileRoute(
  '/_auth/internal-documents/my',
)()
const AuthInternalDocumentsAllLazyRouteImport = createFileRoute(
  '/_auth/internal-documents/all',
)()
const AuthGamesUnconfirmedLazyRouteImport = createFileRoute(
  '/_auth/games/unconfirmed',
)()
const AuthGamesNewLazyRouteImport = createFileRoute('/_auth/games/new')()
const AuthGamesImportLazyRouteImport = createFileRoute('/_auth/games/import')()
const AuthGamesAssignLazyRouteImport = createFileRoute('/_auth/games/assign')()
const AuthGamesGameIdLazyRouteImport = createFileRoute('/_auth/games/$gameId')()
const AuthGameDocumentsAllLazyRouteImport = createFileRoute(
  '/_auth/game-documents/all',
)()
const AuthEvaluationEvaluationIdLazyRouteImport = createFileRoute(
  '/_auth/evaluation/$evaluationId',
)()
const AuthDocumentsCategoryIdLazyRouteImport = createFileRoute(
  '/_auth/documents/$categoryId',
)()
const AuthBalanceImportLazyRouteImport = createFileRoute(
  '/_auth/balance/import',
)()
const AuthAvailabilityUsersAvailabilityLazyRouteImport = createFileRoute(
  '/_auth/availability/users-availability',
)()
const AuthAdminReportsLazyRouteImport = createFileRoute(
  '/_auth/admin/reports',
)()
const AuthAdminMailForUsersLazyRouteImport = createFileRoute(
  '/_auth/admin/mail-for-users',
)()
const AuthLeaguesTripRankingsIndexLazyRouteImport = createFileRoute(
  '/_auth/leagues/trip-rankings/',
)()
const AuthLeaguesLeagueGroupsIndexLazyRouteImport = createFileRoute(
  '/_auth/leagues/league-groups/',
)()
const AuthLeaguesCategoriesIndexLazyRouteImport = createFileRoute(
  '/_auth/leagues/categories/',
)()
const AuthInternalVideosCategoryIndexLazyRouteImport = createFileRoute(
  '/_auth/internal-videos/category/',
)()
const AuthUsersEditUserIdLazyRouteImport = createFileRoute(
  '/_auth/users/edit/$userId',
)()
const AuthTestsEditTestIdLazyRouteImport = createFileRoute(
  '/_auth/tests/edit/$testId',
)()
const AuthTestsTestIdSolveLazyRouteImport = createFileRoute(
  '/_auth/tests/$testId/solve',
)()
const AuthTestsTestIdResultsLazyRouteImport = createFileRoute(
  '/_auth/tests/$testId/results',
)()
const AuthTestsTestIdAnswersLazyRouteImport = createFileRoute(
  '/_auth/tests/$testId/answers',
)()
const AuthPostsEditPostIdLazyRouteImport = createFileRoute(
  '/_auth/posts/edit/$postId',
)()
const AuthLeaguesTripRankingsNewLazyRouteImport = createFileRoute(
  '/_auth/leagues/trip-rankings/new',
)()
const AuthLeaguesTripRankingsTripRankingIdLazyRouteImport = createFileRoute(
  '/_auth/leagues/trip-rankings/$tripRankingId',
)()
const AuthLeaguesLeagueGroupsNewLazyRouteImport = createFileRoute(
  '/_auth/leagues/league-groups/new',
)()
const AuthLeaguesLeagueGroupsGroupIdLazyRouteImport = createFileRoute(
  '/_auth/leagues/league-groups/$groupId',
)()
const AuthLeaguesEditLeagueIdLazyRouteImport = createFileRoute(
  '/_auth/leagues/edit/$leagueId',
)()
const AuthJournalUserUserIdLazyRouteImport = createFileRoute(
  '/_auth/journal/user/$userId',
)()
const AuthInternalVideosEditVideoIdLazyRouteImport = createFileRoute(
  '/_auth/internal-videos/edit/$videoId',
)()
const AuthInternalReviewsEditReviewIdLazyRouteImport = createFileRoute(
  '/_auth/internal-reviews/edit/$reviewId',
)()
const AuthGamesEditGameIdLazyRouteImport = createFileRoute(
  '/_auth/games/edit/$gameId',
)()
const AuthEvaluationRefereeEvaluationGameIdLazyRouteImport = createFileRoute(
  '/_auth/evaluation/referee-evaluation/$gameId',
)()
const AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRouteImport =
  createFileRoute('/_auth/evaluation/referee-evaluation-view/$evaluationId')()
const AuthEvaluationEditGameIdLazyRouteImport = createFileRoute(
  '/_auth/evaluation/edit/$gameId',
)()
const AuthAvailabilityUserUserIdLazyRouteImport = createFileRoute(
  '/_auth/availability/user/$userId',
)()
const AuthLeaguesTripRankingsEditTripRankingIdLazyRouteImport = createFileRoute(
  '/_auth/leagues/trip-rankings/edit/$tripRankingId',
)()
const AuthLeaguesLeagueGroupsEditGroupIdLazyRouteImport = createFileRoute(
  '/_auth/leagues/league-groups/edit/$groupId',
)()

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthUserProfileLazyRoute = AuthUserProfileLazyRouteImport.update({
  id: '/user-profile',
  path: '/user-profile',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/user-profile.lazy').then((d) => d.Route),
)
const AuthChangePasswordLazyRoute = AuthChangePasswordLazyRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/change-password.lazy').then((d) => d.Route),
)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const AuthVideoIndexLazyRoute = AuthVideoIndexLazyRouteImport.update({
  id: '/video/',
  path: '/video/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/video/index.lazy').then((d) => d.Route),
)
const AuthUsersIndexLazyRoute = AuthUsersIndexLazyRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/index.lazy').then((d) => d.Route),
)
const AuthTestsIndexLazyRoute = AuthTestsIndexLazyRouteImport.update({
  id: '/tests/',
  path: '/tests/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/tests/index.lazy').then((d) => d.Route),
)
const AuthScheduleIndexLazyRoute = AuthScheduleIndexLazyRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/schedule/index.lazy').then((d) => d.Route),
)
const AuthLeaguesIndexLazyRoute = AuthLeaguesIndexLazyRouteImport.update({
  id: '/leagues/',
  path: '/leagues/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/leagues/index.lazy').then((d) => d.Route),
)
const AuthInvoicesIndexLazyRoute = AuthInvoicesIndexLazyRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/invoices/index.lazy').then((d) => d.Route),
)
const AuthInternalReviewsIndexLazyRoute =
  AuthInternalReviewsIndexLazyRouteImport.update({
    id: '/internal-reviews/',
    path: '/internal-reviews/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-reviews/index.lazy').then((d) => d.Route),
  )
const AuthIdentityCardsIndexLazyRoute =
  AuthIdentityCardsIndexLazyRouteImport.update({
    id: '/identity-cards/',
    path: '/identity-cards/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/identity-cards/index.lazy').then((d) => d.Route),
  )
const AuthDocumentsIndexLazyRoute = AuthDocumentsIndexLazyRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/documents/index.lazy').then((d) => d.Route),
)
const AuthBalanceIndexLazyRoute = AuthBalanceIndexLazyRouteImport.update({
  id: '/balance/',
  path: '/balance/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/balance/index.lazy').then((d) => d.Route),
)
const AuthAvailabilityIndexLazyRoute =
  AuthAvailabilityIndexLazyRouteImport.update({
    id: '/availability/',
    path: '/availability/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/availability/index.lazy').then((d) => d.Route),
  )
const AuthVideoVideoGroupIdLazyRoute =
  AuthVideoVideoGroupIdLazyRouteImport.update({
    id: '/video/$videoGroupId',
    path: '/video/$videoGroupId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/video/$videoGroupId.lazy').then((d) => d.Route),
  )
const AuthUsersNewLazyRoute = AuthUsersNewLazyRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/new.lazy').then((d) => d.Route),
)
const AuthUsersImportLazyRoute = AuthUsersImportLazyRouteImport.update({
  id: '/users/import',
  path: '/users/import',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/import.lazy').then((d) => d.Route),
)
const AuthUsersUserIdLazyRoute = AuthUsersUserIdLazyRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/$userId.lazy').then((d) => d.Route),
)
const AuthTestsNewLazyRoute = AuthTestsNewLazyRouteImport.update({
  id: '/tests/new',
  path: '/tests/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/tests/new.lazy').then((d) => d.Route),
)
const AuthScheduleMyLazyRoute = AuthScheduleMyLazyRouteImport.update({
  id: '/schedule/my',
  path: '/schedule/my',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/schedule/my.lazy').then((d) => d.Route),
)
const AuthScheduleFullLazyRoute = AuthScheduleFullLazyRouteImport.update({
  id: '/schedule/full',
  path: '/schedule/full',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/schedule/full.lazy').then((d) => d.Route),
)
const AuthScheduleExportLazyRoute = AuthScheduleExportLazyRouteImport.update({
  id: '/schedule/export',
  path: '/schedule/export',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/schedule/export.lazy').then((d) => d.Route),
)
const AuthRefereeEvaluationStatisticsLazyRoute =
  AuthRefereeEvaluationStatisticsLazyRouteImport.update({
    id: '/referee-evaluation/statistics',
    path: '/referee-evaluation/statistics',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/referee-evaluation/statistics.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthPostsNewLazyRoute = AuthPostsNewLazyRouteImport.update({
  id: '/posts/new',
  path: '/posts/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/posts/new.lazy').then((d) => d.Route),
)
const AuthLeaguesNewLazyRoute = AuthLeaguesNewLazyRouteImport.update({
  id: '/leagues/new',
  path: '/leagues/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/leagues/new.lazy').then((d) => d.Route),
)
const AuthLeaguesLeagueIdLazyRoute = AuthLeaguesLeagueIdLazyRouteImport.update({
  id: '/leagues/$leagueId',
  path: '/leagues/$leagueId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/leagues/$leagueId.lazy').then((d) => d.Route),
)
const AuthJournalUsersRankingLazyRoute =
  AuthJournalUsersRankingLazyRouteImport.update({
    id: '/journal/users-ranking',
    path: '/journal/users-ranking',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/journal/users-ranking.lazy').then((d) => d.Route),
  )
const AuthJournalRankingLazyRoute = AuthJournalRankingLazyRouteImport.update({
  id: '/journal/ranking',
  path: '/journal/ranking',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/ranking.lazy').then((d) => d.Route),
)
const AuthJournalMyLazyRoute = AuthJournalMyLazyRouteImport.update({
  id: '/journal/my',
  path: '/journal/my',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/my.lazy').then((d) => d.Route),
)
const AuthJournalExportLazyRoute = AuthJournalExportLazyRouteImport.update({
  id: '/journal/export',
  path: '/journal/export',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/export.lazy').then((d) => d.Route),
)
const AuthJournalExpensesLazyRoute = AuthJournalExpensesLazyRouteImport.update({
  id: '/journal/expenses',
  path: '/journal/expenses',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/expenses.lazy').then((d) => d.Route),
)
const AuthJournalBalanceLazyRoute = AuthJournalBalanceLazyRouteImport.update({
  id: '/journal/balance',
  path: '/journal/balance',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/journal/balance.lazy').then((d) => d.Route),
)
const AuthInvoicesNewLazyRoute = AuthInvoicesNewLazyRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/invoices/new.lazy').then((d) => d.Route),
)
const AuthInternalVideosNewLazyRoute =
  AuthInternalVideosNewLazyRouteImport.update({
    id: '/internal-videos/new',
    path: '/internal-videos/new',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-videos/new.lazy').then((d) => d.Route),
  )
const AuthInternalVideosMyLazyRoute =
  AuthInternalVideosMyLazyRouteImport.update({
    id: '/internal-videos/my',
    path: '/internal-videos/my',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-videos/my.lazy').then((d) => d.Route),
  )
const AuthInternalVideosAllLazyRoute =
  AuthInternalVideosAllLazyRouteImport.update({
    id: '/internal-videos/all',
    path: '/internal-videos/all',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-videos/all.lazy').then((d) => d.Route),
  )
const AuthInternalReviewsNewLazyRoute =
  AuthInternalReviewsNewLazyRouteImport.update({
    id: '/internal-reviews/new',
    path: '/internal-reviews/new',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-reviews/new.lazy').then((d) => d.Route),
  )
const AuthInternalReviewsReviewIdLazyRoute =
  AuthInternalReviewsReviewIdLazyRouteImport.update({
    id: '/internal-reviews/$reviewId',
    path: '/internal-reviews/$reviewId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-reviews/$reviewId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthInternalDocumentsNewLazyRoute =
  AuthInternalDocumentsNewLazyRouteImport.update({
    id: '/internal-documents/new',
    path: '/internal-documents/new',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-documents/new.lazy').then((d) => d.Route),
  )
const AuthInternalDocumentsMyLazyRoute =
  AuthInternalDocumentsMyLazyRouteImport.update({
    id: '/internal-documents/my',
    path: '/internal-documents/my',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-documents/my.lazy').then((d) => d.Route),
  )
const AuthInternalDocumentsAllLazyRoute =
  AuthInternalDocumentsAllLazyRouteImport.update({
    id: '/internal-documents/all',
    path: '/internal-documents/all',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-documents/all.lazy').then((d) => d.Route),
  )
const AuthGamesUnconfirmedLazyRoute =
  AuthGamesUnconfirmedLazyRouteImport.update({
    id: '/games/unconfirmed',
    path: '/games/unconfirmed',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/games/unconfirmed.lazy').then((d) => d.Route),
  )
const AuthGamesNewLazyRoute = AuthGamesNewLazyRouteImport.update({
  id: '/games/new',
  path: '/games/new',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/new.lazy').then((d) => d.Route),
)
const AuthGamesImportLazyRoute = AuthGamesImportLazyRouteImport.update({
  id: '/games/import',
  path: '/games/import',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/import.lazy').then((d) => d.Route),
)
const AuthGamesAssignLazyRoute = AuthGamesAssignLazyRouteImport.update({
  id: '/games/assign',
  path: '/games/assign',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/assign.lazy').then((d) => d.Route),
)
const AuthGamesGameIdLazyRoute = AuthGamesGameIdLazyRouteImport.update({
  id: '/games/$gameId',
  path: '/games/$gameId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/$gameId.lazy').then((d) => d.Route),
)
const AuthGameDocumentsAllLazyRoute =
  AuthGameDocumentsAllLazyRouteImport.update({
    id: '/game-documents/all',
    path: '/game-documents/all',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/game-documents/all.lazy').then((d) => d.Route),
  )
const AuthEvaluationEvaluationIdLazyRoute =
  AuthEvaluationEvaluationIdLazyRouteImport.update({
    id: '/evaluation/$evaluationId',
    path: '/evaluation/$evaluationId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/evaluation/$evaluationId.lazy').then((d) => d.Route),
  )
const AuthDocumentsCategoryIdLazyRoute =
  AuthDocumentsCategoryIdLazyRouteImport.update({
    id: '/documents/$categoryId',
    path: '/documents/$categoryId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/documents/$categoryId.lazy').then((d) => d.Route),
  )
const AuthBalanceImportLazyRoute = AuthBalanceImportLazyRouteImport.update({
  id: '/balance/import',
  path: '/balance/import',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/balance/import.lazy').then((d) => d.Route),
)
const AuthAvailabilityUsersAvailabilityLazyRoute =
  AuthAvailabilityUsersAvailabilityLazyRouteImport.update({
    id: '/availability/users-availability',
    path: '/availability/users-availability',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/availability/users-availability.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAdminReportsLazyRoute = AuthAdminReportsLazyRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/admin/reports.lazy').then((d) => d.Route),
)
const AuthAdminMailForUsersLazyRoute =
  AuthAdminMailForUsersLazyRouteImport.update({
    id: '/admin/mail-for-users',
    path: '/admin/mail-for-users',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/admin/mail-for-users.lazy').then((d) => d.Route),
  )
const AuthLeaguesTripRankingsIndexLazyRoute =
  AuthLeaguesTripRankingsIndexLazyRouteImport.update({
    id: '/leagues/trip-rankings/',
    path: '/leagues/trip-rankings/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/trip-rankings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLeaguesLeagueGroupsIndexLazyRoute =
  AuthLeaguesLeagueGroupsIndexLazyRouteImport.update({
    id: '/leagues/league-groups/',
    path: '/leagues/league-groups/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/league-groups/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLeaguesCategoriesIndexLazyRoute =
  AuthLeaguesCategoriesIndexLazyRouteImport.update({
    id: '/leagues/categories/',
    path: '/leagues/categories/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/categories/index.lazy').then((d) => d.Route),
  )
const AuthInternalVideosCategoryIndexLazyRoute =
  AuthInternalVideosCategoryIndexLazyRouteImport.update({
    id: '/internal-videos/category/',
    path: '/internal-videos/category/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-videos/category/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthUsersEditUserIdLazyRoute = AuthUsersEditUserIdLazyRouteImport.update({
  id: '/users/edit/$userId',
  path: '/users/edit/$userId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/users/edit.$userId.lazy').then((d) => d.Route),
)
const AuthTestsEditTestIdLazyRoute = AuthTestsEditTestIdLazyRouteImport.update({
  id: '/tests/edit/$testId',
  path: '/tests/edit/$testId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/tests/edit.$testId.lazy').then((d) => d.Route),
)
const AuthTestsTestIdSolveLazyRoute =
  AuthTestsTestIdSolveLazyRouteImport.update({
    id: '/tests/$testId/solve',
    path: '/tests/$testId/solve',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/tests/$testId.solve.lazy').then((d) => d.Route),
  )
const AuthTestsTestIdResultsLazyRoute =
  AuthTestsTestIdResultsLazyRouteImport.update({
    id: '/tests/$testId/results',
    path: '/tests/$testId/results',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/tests/$testId.results.lazy').then((d) => d.Route),
  )
const AuthTestsTestIdAnswersLazyRoute =
  AuthTestsTestIdAnswersLazyRouteImport.update({
    id: '/tests/$testId/answers',
    path: '/tests/$testId/answers',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/tests/$testId.answers.lazy').then((d) => d.Route),
  )
const AuthPostsEditPostIdLazyRoute = AuthPostsEditPostIdLazyRouteImport.update({
  id: '/posts/edit/$postId',
  path: '/posts/edit/$postId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/posts/edit.$postId.lazy').then((d) => d.Route),
)
const AuthLeaguesTripRankingsNewLazyRoute =
  AuthLeaguesTripRankingsNewLazyRouteImport.update({
    id: '/leagues/trip-rankings/new',
    path: '/leagues/trip-rankings/new',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/trip-rankings/new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLeaguesTripRankingsTripRankingIdLazyRoute =
  AuthLeaguesTripRankingsTripRankingIdLazyRouteImport.update({
    id: '/leagues/trip-rankings/$tripRankingId',
    path: '/leagues/trip-rankings/$tripRankingId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/trip-rankings/$tripRankingId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLeaguesLeagueGroupsNewLazyRoute =
  AuthLeaguesLeagueGroupsNewLazyRouteImport.update({
    id: '/leagues/league-groups/new',
    path: '/leagues/league-groups/new',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/league-groups/new.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLeaguesLeagueGroupsGroupIdLazyRoute =
  AuthLeaguesLeagueGroupsGroupIdLazyRouteImport.update({
    id: '/leagues/league-groups/$groupId',
    path: '/leagues/league-groups/$groupId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/league-groups/$groupId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLeaguesEditLeagueIdLazyRoute =
  AuthLeaguesEditLeagueIdLazyRouteImport.update({
    id: '/leagues/edit/$leagueId',
    path: '/leagues/edit/$leagueId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/edit.$leagueId.lazy').then((d) => d.Route),
  )
const AuthJournalUserUserIdLazyRoute =
  AuthJournalUserUserIdLazyRouteImport.update({
    id: '/journal/user/$userId',
    path: '/journal/user/$userId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/journal/user.$userId.lazy').then((d) => d.Route),
  )
const AuthInternalVideosEditVideoIdLazyRoute =
  AuthInternalVideosEditVideoIdLazyRouteImport.update({
    id: '/internal-videos/edit/$videoId',
    path: '/internal-videos/edit/$videoId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-videos/edit.$videoId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthInternalReviewsEditReviewIdLazyRoute =
  AuthInternalReviewsEditReviewIdLazyRouteImport.update({
    id: '/internal-reviews/edit/$reviewId',
    path: '/internal-reviews/edit/$reviewId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/internal-reviews/edit.$reviewId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthGamesEditGameIdLazyRoute = AuthGamesEditGameIdLazyRouteImport.update({
  id: '/games/edit/$gameId',
  path: '/games/edit/$gameId',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/games/edit.$gameId.lazy').then((d) => d.Route),
)
const AuthEvaluationRefereeEvaluationGameIdLazyRoute =
  AuthEvaluationRefereeEvaluationGameIdLazyRouteImport.update({
    id: '/evaluation/referee-evaluation/$gameId',
    path: '/evaluation/referee-evaluation/$gameId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/evaluation/referee-evaluation.$gameId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRoute =
  AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRouteImport.update({
    id: '/evaluation/referee-evaluation-view/$evaluationId',
    path: '/evaluation/referee-evaluation-view/$evaluationId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/evaluation/referee-evaluation-view.$evaluationId.lazy'
    ).then((d) => d.Route),
  )
const AuthEvaluationEditGameIdLazyRoute =
  AuthEvaluationEditGameIdLazyRouteImport.update({
    id: '/evaluation/edit/$gameId',
    path: '/evaluation/edit/$gameId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/evaluation/edit.$gameId.lazy').then((d) => d.Route),
  )
const AuthAvailabilityUserUserIdLazyRoute =
  AuthAvailabilityUserUserIdLazyRouteImport.update({
    id: '/availability/user/$userId',
    path: '/availability/user/$userId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/availability/user.$userId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLeaguesTripRankingsEditTripRankingIdLazyRoute =
  AuthLeaguesTripRankingsEditTripRankingIdLazyRouteImport.update({
    id: '/leagues/trip-rankings/edit/$tripRankingId',
    path: '/leagues/trip-rankings/edit/$tripRankingId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/leagues/trip-rankings/edit.$tripRankingId.lazy'
    ).then((d) => d.Route),
  )
const AuthLeaguesLeagueGroupsEditGroupIdLazyRoute =
  AuthLeaguesLeagueGroupsEditGroupIdLazyRouteImport.update({
    id: '/leagues/league-groups/edit/$groupId',
    path: '/leagues/league-groups/edit/$groupId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/leagues/league-groups/edit.$groupId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/change-password': typeof AuthChangePasswordLazyRoute
  '/user-profile': typeof AuthUserProfileLazyRoute
  '/': typeof AuthIndexRoute
  '/admin/mail-for-users': typeof AuthAdminMailForUsersLazyRoute
  '/admin/reports': typeof AuthAdminReportsLazyRoute
  '/availability/users-availability': typeof AuthAvailabilityUsersAvailabilityLazyRoute
  '/balance/import': typeof AuthBalanceImportLazyRoute
  '/documents/$categoryId': typeof AuthDocumentsCategoryIdLazyRoute
  '/evaluation/$evaluationId': typeof AuthEvaluationEvaluationIdLazyRoute
  '/game-documents/all': typeof AuthGameDocumentsAllLazyRoute
  '/games/$gameId': typeof AuthGamesGameIdLazyRoute
  '/games/assign': typeof AuthGamesAssignLazyRoute
  '/games/import': typeof AuthGamesImportLazyRoute
  '/games/new': typeof AuthGamesNewLazyRoute
  '/games/unconfirmed': typeof AuthGamesUnconfirmedLazyRoute
  '/internal-documents/all': typeof AuthInternalDocumentsAllLazyRoute
  '/internal-documents/my': typeof AuthInternalDocumentsMyLazyRoute
  '/internal-documents/new': typeof AuthInternalDocumentsNewLazyRoute
  '/internal-reviews/$reviewId': typeof AuthInternalReviewsReviewIdLazyRoute
  '/internal-reviews/new': typeof AuthInternalReviewsNewLazyRoute
  '/internal-videos/all': typeof AuthInternalVideosAllLazyRoute
  '/internal-videos/my': typeof AuthInternalVideosMyLazyRoute
  '/internal-videos/new': typeof AuthInternalVideosNewLazyRoute
  '/invoices/new': typeof AuthInvoicesNewLazyRoute
  '/journal/balance': typeof AuthJournalBalanceLazyRoute
  '/journal/expenses': typeof AuthJournalExpensesLazyRoute
  '/journal/export': typeof AuthJournalExportLazyRoute
  '/journal/my': typeof AuthJournalMyLazyRoute
  '/journal/ranking': typeof AuthJournalRankingLazyRoute
  '/journal/users-ranking': typeof AuthJournalUsersRankingLazyRoute
  '/leagues/$leagueId': typeof AuthLeaguesLeagueIdLazyRoute
  '/leagues/new': typeof AuthLeaguesNewLazyRoute
  '/posts/new': typeof AuthPostsNewLazyRoute
  '/referee-evaluation/statistics': typeof AuthRefereeEvaluationStatisticsLazyRoute
  '/schedule/export': typeof AuthScheduleExportLazyRoute
  '/schedule/full': typeof AuthScheduleFullLazyRoute
  '/schedule/my': typeof AuthScheduleMyLazyRoute
  '/tests/new': typeof AuthTestsNewLazyRoute
  '/users/$userId': typeof AuthUsersUserIdLazyRoute
  '/users/import': typeof AuthUsersImportLazyRoute
  '/users/new': typeof AuthUsersNewLazyRoute
  '/video/$videoGroupId': typeof AuthVideoVideoGroupIdLazyRoute
  '/availability': typeof AuthAvailabilityIndexLazyRoute
  '/balance': typeof AuthBalanceIndexLazyRoute
  '/documents': typeof AuthDocumentsIndexLazyRoute
  '/identity-cards': typeof AuthIdentityCardsIndexLazyRoute
  '/internal-reviews': typeof AuthInternalReviewsIndexLazyRoute
  '/invoices': typeof AuthInvoicesIndexLazyRoute
  '/leagues': typeof AuthLeaguesIndexLazyRoute
  '/schedule': typeof AuthScheduleIndexLazyRoute
  '/tests': typeof AuthTestsIndexLazyRoute
  '/users': typeof AuthUsersIndexLazyRoute
  '/video': typeof AuthVideoIndexLazyRoute
  '/availability/user/$userId': typeof AuthAvailabilityUserUserIdLazyRoute
  '/evaluation/edit/$gameId': typeof AuthEvaluationEditGameIdLazyRoute
  '/evaluation/referee-evaluation-view/$evaluationId': typeof AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRoute
  '/evaluation/referee-evaluation/$gameId': typeof AuthEvaluationRefereeEvaluationGameIdLazyRoute
  '/games/edit/$gameId': typeof AuthGamesEditGameIdLazyRoute
  '/internal-reviews/edit/$reviewId': typeof AuthInternalReviewsEditReviewIdLazyRoute
  '/internal-videos/edit/$videoId': typeof AuthInternalVideosEditVideoIdLazyRoute
  '/journal/user/$userId': typeof AuthJournalUserUserIdLazyRoute
  '/leagues/edit/$leagueId': typeof AuthLeaguesEditLeagueIdLazyRoute
  '/leagues/league-groups/$groupId': typeof AuthLeaguesLeagueGroupsGroupIdLazyRoute
  '/leagues/league-groups/new': typeof AuthLeaguesLeagueGroupsNewLazyRoute
  '/leagues/trip-rankings/$tripRankingId': typeof AuthLeaguesTripRankingsTripRankingIdLazyRoute
  '/leagues/trip-rankings/new': typeof AuthLeaguesTripRankingsNewLazyRoute
  '/posts/edit/$postId': typeof AuthPostsEditPostIdLazyRoute
  '/tests/$testId/answers': typeof AuthTestsTestIdAnswersLazyRoute
  '/tests/$testId/results': typeof AuthTestsTestIdResultsLazyRoute
  '/tests/$testId/solve': typeof AuthTestsTestIdSolveLazyRoute
  '/tests/edit/$testId': typeof AuthTestsEditTestIdLazyRoute
  '/users/edit/$userId': typeof AuthUsersEditUserIdLazyRoute
  '/internal-videos/category': typeof AuthInternalVideosCategoryIndexLazyRoute
  '/leagues/categories': typeof AuthLeaguesCategoriesIndexLazyRoute
  '/leagues/league-groups': typeof AuthLeaguesLeagueGroupsIndexLazyRoute
  '/leagues/trip-rankings': typeof AuthLeaguesTripRankingsIndexLazyRoute
  '/leagues/league-groups/edit/$groupId': typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRoute
  '/leagues/trip-rankings/edit/$tripRankingId': typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/change-password': typeof AuthChangePasswordLazyRoute
  '/user-profile': typeof AuthUserProfileLazyRoute
  '/': typeof AuthIndexRoute
  '/admin/mail-for-users': typeof AuthAdminMailForUsersLazyRoute
  '/admin/reports': typeof AuthAdminReportsLazyRoute
  '/availability/users-availability': typeof AuthAvailabilityUsersAvailabilityLazyRoute
  '/balance/import': typeof AuthBalanceImportLazyRoute
  '/documents/$categoryId': typeof AuthDocumentsCategoryIdLazyRoute
  '/evaluation/$evaluationId': typeof AuthEvaluationEvaluationIdLazyRoute
  '/game-documents/all': typeof AuthGameDocumentsAllLazyRoute
  '/games/$gameId': typeof AuthGamesGameIdLazyRoute
  '/games/assign': typeof AuthGamesAssignLazyRoute
  '/games/import': typeof AuthGamesImportLazyRoute
  '/games/new': typeof AuthGamesNewLazyRoute
  '/games/unconfirmed': typeof AuthGamesUnconfirmedLazyRoute
  '/internal-documents/all': typeof AuthInternalDocumentsAllLazyRoute
  '/internal-documents/my': typeof AuthInternalDocumentsMyLazyRoute
  '/internal-documents/new': typeof AuthInternalDocumentsNewLazyRoute
  '/internal-reviews/$reviewId': typeof AuthInternalReviewsReviewIdLazyRoute
  '/internal-reviews/new': typeof AuthInternalReviewsNewLazyRoute
  '/internal-videos/all': typeof AuthInternalVideosAllLazyRoute
  '/internal-videos/my': typeof AuthInternalVideosMyLazyRoute
  '/internal-videos/new': typeof AuthInternalVideosNewLazyRoute
  '/invoices/new': typeof AuthInvoicesNewLazyRoute
  '/journal/balance': typeof AuthJournalBalanceLazyRoute
  '/journal/expenses': typeof AuthJournalExpensesLazyRoute
  '/journal/export': typeof AuthJournalExportLazyRoute
  '/journal/my': typeof AuthJournalMyLazyRoute
  '/journal/ranking': typeof AuthJournalRankingLazyRoute
  '/journal/users-ranking': typeof AuthJournalUsersRankingLazyRoute
  '/leagues/$leagueId': typeof AuthLeaguesLeagueIdLazyRoute
  '/leagues/new': typeof AuthLeaguesNewLazyRoute
  '/posts/new': typeof AuthPostsNewLazyRoute
  '/referee-evaluation/statistics': typeof AuthRefereeEvaluationStatisticsLazyRoute
  '/schedule/export': typeof AuthScheduleExportLazyRoute
  '/schedule/full': typeof AuthScheduleFullLazyRoute
  '/schedule/my': typeof AuthScheduleMyLazyRoute
  '/tests/new': typeof AuthTestsNewLazyRoute
  '/users/$userId': typeof AuthUsersUserIdLazyRoute
  '/users/import': typeof AuthUsersImportLazyRoute
  '/users/new': typeof AuthUsersNewLazyRoute
  '/video/$videoGroupId': typeof AuthVideoVideoGroupIdLazyRoute
  '/availability': typeof AuthAvailabilityIndexLazyRoute
  '/balance': typeof AuthBalanceIndexLazyRoute
  '/documents': typeof AuthDocumentsIndexLazyRoute
  '/identity-cards': typeof AuthIdentityCardsIndexLazyRoute
  '/internal-reviews': typeof AuthInternalReviewsIndexLazyRoute
  '/invoices': typeof AuthInvoicesIndexLazyRoute
  '/leagues': typeof AuthLeaguesIndexLazyRoute
  '/schedule': typeof AuthScheduleIndexLazyRoute
  '/tests': typeof AuthTestsIndexLazyRoute
  '/users': typeof AuthUsersIndexLazyRoute
  '/video': typeof AuthVideoIndexLazyRoute
  '/availability/user/$userId': typeof AuthAvailabilityUserUserIdLazyRoute
  '/evaluation/edit/$gameId': typeof AuthEvaluationEditGameIdLazyRoute
  '/evaluation/referee-evaluation-view/$evaluationId': typeof AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRoute
  '/evaluation/referee-evaluation/$gameId': typeof AuthEvaluationRefereeEvaluationGameIdLazyRoute
  '/games/edit/$gameId': typeof AuthGamesEditGameIdLazyRoute
  '/internal-reviews/edit/$reviewId': typeof AuthInternalReviewsEditReviewIdLazyRoute
  '/internal-videos/edit/$videoId': typeof AuthInternalVideosEditVideoIdLazyRoute
  '/journal/user/$userId': typeof AuthJournalUserUserIdLazyRoute
  '/leagues/edit/$leagueId': typeof AuthLeaguesEditLeagueIdLazyRoute
  '/leagues/league-groups/$groupId': typeof AuthLeaguesLeagueGroupsGroupIdLazyRoute
  '/leagues/league-groups/new': typeof AuthLeaguesLeagueGroupsNewLazyRoute
  '/leagues/trip-rankings/$tripRankingId': typeof AuthLeaguesTripRankingsTripRankingIdLazyRoute
  '/leagues/trip-rankings/new': typeof AuthLeaguesTripRankingsNewLazyRoute
  '/posts/edit/$postId': typeof AuthPostsEditPostIdLazyRoute
  '/tests/$testId/answers': typeof AuthTestsTestIdAnswersLazyRoute
  '/tests/$testId/results': typeof AuthTestsTestIdResultsLazyRoute
  '/tests/$testId/solve': typeof AuthTestsTestIdSolveLazyRoute
  '/tests/edit/$testId': typeof AuthTestsEditTestIdLazyRoute
  '/users/edit/$userId': typeof AuthUsersEditUserIdLazyRoute
  '/internal-videos/category': typeof AuthInternalVideosCategoryIndexLazyRoute
  '/leagues/categories': typeof AuthLeaguesCategoriesIndexLazyRoute
  '/leagues/league-groups': typeof AuthLeaguesLeagueGroupsIndexLazyRoute
  '/leagues/trip-rankings': typeof AuthLeaguesTripRankingsIndexLazyRoute
  '/leagues/league-groups/edit/$groupId': typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRoute
  '/leagues/trip-rankings/edit/$tripRankingId': typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_auth/change-password': typeof AuthChangePasswordLazyRoute
  '/_auth/user-profile': typeof AuthUserProfileLazyRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/mail-for-users': typeof AuthAdminMailForUsersLazyRoute
  '/_auth/admin/reports': typeof AuthAdminReportsLazyRoute
  '/_auth/availability/users-availability': typeof AuthAvailabilityUsersAvailabilityLazyRoute
  '/_auth/balance/import': typeof AuthBalanceImportLazyRoute
  '/_auth/documents/$categoryId': typeof AuthDocumentsCategoryIdLazyRoute
  '/_auth/evaluation/$evaluationId': typeof AuthEvaluationEvaluationIdLazyRoute
  '/_auth/game-documents/all': typeof AuthGameDocumentsAllLazyRoute
  '/_auth/games/$gameId': typeof AuthGamesGameIdLazyRoute
  '/_auth/games/assign': typeof AuthGamesAssignLazyRoute
  '/_auth/games/import': typeof AuthGamesImportLazyRoute
  '/_auth/games/new': typeof AuthGamesNewLazyRoute
  '/_auth/games/unconfirmed': typeof AuthGamesUnconfirmedLazyRoute
  '/_auth/internal-documents/all': typeof AuthInternalDocumentsAllLazyRoute
  '/_auth/internal-documents/my': typeof AuthInternalDocumentsMyLazyRoute
  '/_auth/internal-documents/new': typeof AuthInternalDocumentsNewLazyRoute
  '/_auth/internal-reviews/$reviewId': typeof AuthInternalReviewsReviewIdLazyRoute
  '/_auth/internal-reviews/new': typeof AuthInternalReviewsNewLazyRoute
  '/_auth/internal-videos/all': typeof AuthInternalVideosAllLazyRoute
  '/_auth/internal-videos/my': typeof AuthInternalVideosMyLazyRoute
  '/_auth/internal-videos/new': typeof AuthInternalVideosNewLazyRoute
  '/_auth/invoices/new': typeof AuthInvoicesNewLazyRoute
  '/_auth/journal/balance': typeof AuthJournalBalanceLazyRoute
  '/_auth/journal/expenses': typeof AuthJournalExpensesLazyRoute
  '/_auth/journal/export': typeof AuthJournalExportLazyRoute
  '/_auth/journal/my': typeof AuthJournalMyLazyRoute
  '/_auth/journal/ranking': typeof AuthJournalRankingLazyRoute
  '/_auth/journal/users-ranking': typeof AuthJournalUsersRankingLazyRoute
  '/_auth/leagues/$leagueId': typeof AuthLeaguesLeagueIdLazyRoute
  '/_auth/leagues/new': typeof AuthLeaguesNewLazyRoute
  '/_auth/posts/new': typeof AuthPostsNewLazyRoute
  '/_auth/referee-evaluation/statistics': typeof AuthRefereeEvaluationStatisticsLazyRoute
  '/_auth/schedule/export': typeof AuthScheduleExportLazyRoute
  '/_auth/schedule/full': typeof AuthScheduleFullLazyRoute
  '/_auth/schedule/my': typeof AuthScheduleMyLazyRoute
  '/_auth/tests/new': typeof AuthTestsNewLazyRoute
  '/_auth/users/$userId': typeof AuthUsersUserIdLazyRoute
  '/_auth/users/import': typeof AuthUsersImportLazyRoute
  '/_auth/users/new': typeof AuthUsersNewLazyRoute
  '/_auth/video/$videoGroupId': typeof AuthVideoVideoGroupIdLazyRoute
  '/_auth/availability/': typeof AuthAvailabilityIndexLazyRoute
  '/_auth/balance/': typeof AuthBalanceIndexLazyRoute
  '/_auth/documents/': typeof AuthDocumentsIndexLazyRoute
  '/_auth/identity-cards/': typeof AuthIdentityCardsIndexLazyRoute
  '/_auth/internal-reviews/': typeof AuthInternalReviewsIndexLazyRoute
  '/_auth/invoices/': typeof AuthInvoicesIndexLazyRoute
  '/_auth/leagues/': typeof AuthLeaguesIndexLazyRoute
  '/_auth/schedule/': typeof AuthScheduleIndexLazyRoute
  '/_auth/tests/': typeof AuthTestsIndexLazyRoute
  '/_auth/users/': typeof AuthUsersIndexLazyRoute
  '/_auth/video/': typeof AuthVideoIndexLazyRoute
  '/_auth/availability/user/$userId': typeof AuthAvailabilityUserUserIdLazyRoute
  '/_auth/evaluation/edit/$gameId': typeof AuthEvaluationEditGameIdLazyRoute
  '/_auth/evaluation/referee-evaluation-view/$evaluationId': typeof AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRoute
  '/_auth/evaluation/referee-evaluation/$gameId': typeof AuthEvaluationRefereeEvaluationGameIdLazyRoute
  '/_auth/games/edit/$gameId': typeof AuthGamesEditGameIdLazyRoute
  '/_auth/internal-reviews/edit/$reviewId': typeof AuthInternalReviewsEditReviewIdLazyRoute
  '/_auth/internal-videos/edit/$videoId': typeof AuthInternalVideosEditVideoIdLazyRoute
  '/_auth/journal/user/$userId': typeof AuthJournalUserUserIdLazyRoute
  '/_auth/leagues/edit/$leagueId': typeof AuthLeaguesEditLeagueIdLazyRoute
  '/_auth/leagues/league-groups/$groupId': typeof AuthLeaguesLeagueGroupsGroupIdLazyRoute
  '/_auth/leagues/league-groups/new': typeof AuthLeaguesLeagueGroupsNewLazyRoute
  '/_auth/leagues/trip-rankings/$tripRankingId': typeof AuthLeaguesTripRankingsTripRankingIdLazyRoute
  '/_auth/leagues/trip-rankings/new': typeof AuthLeaguesTripRankingsNewLazyRoute
  '/_auth/posts/edit/$postId': typeof AuthPostsEditPostIdLazyRoute
  '/_auth/tests/$testId/answers': typeof AuthTestsTestIdAnswersLazyRoute
  '/_auth/tests/$testId/results': typeof AuthTestsTestIdResultsLazyRoute
  '/_auth/tests/$testId/solve': typeof AuthTestsTestIdSolveLazyRoute
  '/_auth/tests/edit/$testId': typeof AuthTestsEditTestIdLazyRoute
  '/_auth/users/edit/$userId': typeof AuthUsersEditUserIdLazyRoute
  '/_auth/internal-videos/category/': typeof AuthInternalVideosCategoryIndexLazyRoute
  '/_auth/leagues/categories/': typeof AuthLeaguesCategoriesIndexLazyRoute
  '/_auth/leagues/league-groups/': typeof AuthLeaguesLeagueGroupsIndexLazyRoute
  '/_auth/leagues/trip-rankings/': typeof AuthLeaguesTripRankingsIndexLazyRoute
  '/_auth/leagues/league-groups/edit/$groupId': typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRoute
  '/_auth/leagues/trip-rankings/edit/$tripRankingId': typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forgot-password'
    | '/login'
    | '/change-password'
    | '/user-profile'
    | '/'
    | '/admin/mail-for-users'
    | '/admin/reports'
    | '/availability/users-availability'
    | '/balance/import'
    | '/documents/$categoryId'
    | '/evaluation/$evaluationId'
    | '/game-documents/all'
    | '/games/$gameId'
    | '/games/assign'
    | '/games/import'
    | '/games/new'
    | '/games/unconfirmed'
    | '/internal-documents/all'
    | '/internal-documents/my'
    | '/internal-documents/new'
    | '/internal-reviews/$reviewId'
    | '/internal-reviews/new'
    | '/internal-videos/all'
    | '/internal-videos/my'
    | '/internal-videos/new'
    | '/invoices/new'
    | '/journal/balance'
    | '/journal/expenses'
    | '/journal/export'
    | '/journal/my'
    | '/journal/ranking'
    | '/journal/users-ranking'
    | '/leagues/$leagueId'
    | '/leagues/new'
    | '/posts/new'
    | '/referee-evaluation/statistics'
    | '/schedule/export'
    | '/schedule/full'
    | '/schedule/my'
    | '/tests/new'
    | '/users/$userId'
    | '/users/import'
    | '/users/new'
    | '/video/$videoGroupId'
    | '/availability'
    | '/balance'
    | '/documents'
    | '/identity-cards'
    | '/internal-reviews'
    | '/invoices'
    | '/leagues'
    | '/schedule'
    | '/tests'
    | '/users'
    | '/video'
    | '/availability/user/$userId'
    | '/evaluation/edit/$gameId'
    | '/evaluation/referee-evaluation-view/$evaluationId'
    | '/evaluation/referee-evaluation/$gameId'
    | '/games/edit/$gameId'
    | '/internal-reviews/edit/$reviewId'
    | '/internal-videos/edit/$videoId'
    | '/journal/user/$userId'
    | '/leagues/edit/$leagueId'
    | '/leagues/league-groups/$groupId'
    | '/leagues/league-groups/new'
    | '/leagues/trip-rankings/$tripRankingId'
    | '/leagues/trip-rankings/new'
    | '/posts/edit/$postId'
    | '/tests/$testId/answers'
    | '/tests/$testId/results'
    | '/tests/$testId/solve'
    | '/tests/edit/$testId'
    | '/users/edit/$userId'
    | '/internal-videos/category'
    | '/leagues/categories'
    | '/leagues/league-groups'
    | '/leagues/trip-rankings'
    | '/leagues/league-groups/edit/$groupId'
    | '/leagues/trip-rankings/edit/$tripRankingId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/change-password'
    | '/user-profile'
    | '/'
    | '/admin/mail-for-users'
    | '/admin/reports'
    | '/availability/users-availability'
    | '/balance/import'
    | '/documents/$categoryId'
    | '/evaluation/$evaluationId'
    | '/game-documents/all'
    | '/games/$gameId'
    | '/games/assign'
    | '/games/import'
    | '/games/new'
    | '/games/unconfirmed'
    | '/internal-documents/all'
    | '/internal-documents/my'
    | '/internal-documents/new'
    | '/internal-reviews/$reviewId'
    | '/internal-reviews/new'
    | '/internal-videos/all'
    | '/internal-videos/my'
    | '/internal-videos/new'
    | '/invoices/new'
    | '/journal/balance'
    | '/journal/expenses'
    | '/journal/export'
    | '/journal/my'
    | '/journal/ranking'
    | '/journal/users-ranking'
    | '/leagues/$leagueId'
    | '/leagues/new'
    | '/posts/new'
    | '/referee-evaluation/statistics'
    | '/schedule/export'
    | '/schedule/full'
    | '/schedule/my'
    | '/tests/new'
    | '/users/$userId'
    | '/users/import'
    | '/users/new'
    | '/video/$videoGroupId'
    | '/availability'
    | '/balance'
    | '/documents'
    | '/identity-cards'
    | '/internal-reviews'
    | '/invoices'
    | '/leagues'
    | '/schedule'
    | '/tests'
    | '/users'
    | '/video'
    | '/availability/user/$userId'
    | '/evaluation/edit/$gameId'
    | '/evaluation/referee-evaluation-view/$evaluationId'
    | '/evaluation/referee-evaluation/$gameId'
    | '/games/edit/$gameId'
    | '/internal-reviews/edit/$reviewId'
    | '/internal-videos/edit/$videoId'
    | '/journal/user/$userId'
    | '/leagues/edit/$leagueId'
    | '/leagues/league-groups/$groupId'
    | '/leagues/league-groups/new'
    | '/leagues/trip-rankings/$tripRankingId'
    | '/leagues/trip-rankings/new'
    | '/posts/edit/$postId'
    | '/tests/$testId/answers'
    | '/tests/$testId/results'
    | '/tests/$testId/solve'
    | '/tests/edit/$testId'
    | '/users/edit/$userId'
    | '/internal-videos/category'
    | '/leagues/categories'
    | '/leagues/league-groups'
    | '/leagues/trip-rankings'
    | '/leagues/league-groups/edit/$groupId'
    | '/leagues/trip-rankings/edit/$tripRankingId'
  id:
    | '__root__'
    | '/_auth'
    | '/_public'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_auth/change-password'
    | '/_auth/user-profile'
    | '/_auth/'
    | '/_auth/admin/mail-for-users'
    | '/_auth/admin/reports'
    | '/_auth/availability/users-availability'
    | '/_auth/balance/import'
    | '/_auth/documents/$categoryId'
    | '/_auth/evaluation/$evaluationId'
    | '/_auth/game-documents/all'
    | '/_auth/games/$gameId'
    | '/_auth/games/assign'
    | '/_auth/games/import'
    | '/_auth/games/new'
    | '/_auth/games/unconfirmed'
    | '/_auth/internal-documents/all'
    | '/_auth/internal-documents/my'
    | '/_auth/internal-documents/new'
    | '/_auth/internal-reviews/$reviewId'
    | '/_auth/internal-reviews/new'
    | '/_auth/internal-videos/all'
    | '/_auth/internal-videos/my'
    | '/_auth/internal-videos/new'
    | '/_auth/invoices/new'
    | '/_auth/journal/balance'
    | '/_auth/journal/expenses'
    | '/_auth/journal/export'
    | '/_auth/journal/my'
    | '/_auth/journal/ranking'
    | '/_auth/journal/users-ranking'
    | '/_auth/leagues/$leagueId'
    | '/_auth/leagues/new'
    | '/_auth/posts/new'
    | '/_auth/referee-evaluation/statistics'
    | '/_auth/schedule/export'
    | '/_auth/schedule/full'
    | '/_auth/schedule/my'
    | '/_auth/tests/new'
    | '/_auth/users/$userId'
    | '/_auth/users/import'
    | '/_auth/users/new'
    | '/_auth/video/$videoGroupId'
    | '/_auth/availability/'
    | '/_auth/balance/'
    | '/_auth/documents/'
    | '/_auth/identity-cards/'
    | '/_auth/internal-reviews/'
    | '/_auth/invoices/'
    | '/_auth/leagues/'
    | '/_auth/schedule/'
    | '/_auth/tests/'
    | '/_auth/users/'
    | '/_auth/video/'
    | '/_auth/availability/user/$userId'
    | '/_auth/evaluation/edit/$gameId'
    | '/_auth/evaluation/referee-evaluation-view/$evaluationId'
    | '/_auth/evaluation/referee-evaluation/$gameId'
    | '/_auth/games/edit/$gameId'
    | '/_auth/internal-reviews/edit/$reviewId'
    | '/_auth/internal-videos/edit/$videoId'
    | '/_auth/journal/user/$userId'
    | '/_auth/leagues/edit/$leagueId'
    | '/_auth/leagues/league-groups/$groupId'
    | '/_auth/leagues/league-groups/new'
    | '/_auth/leagues/trip-rankings/$tripRankingId'
    | '/_auth/leagues/trip-rankings/new'
    | '/_auth/posts/edit/$postId'
    | '/_auth/tests/$testId/answers'
    | '/_auth/tests/$testId/results'
    | '/_auth/tests/$testId/solve'
    | '/_auth/tests/edit/$testId'
    | '/_auth/users/edit/$userId'
    | '/_auth/internal-videos/category/'
    | '/_auth/leagues/categories/'
    | '/_auth/leagues/league-groups/'
    | '/_auth/leagues/trip-rankings/'
    | '/_auth/leagues/league-groups/edit/$groupId'
    | '/_auth/leagues/trip-rankings/edit/$tripRankingId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/user-profile': {
      id: '/_auth/user-profile'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof AuthUserProfileLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/video/': {
      id: '/_auth/video/'
      path: '/video'
      fullPath: '/video'
      preLoaderRoute: typeof AuthVideoIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/users/': {
      id: '/_auth/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/tests/': {
      id: '/_auth/tests/'
      path: '/tests'
      fullPath: '/tests'
      preLoaderRoute: typeof AuthTestsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/schedule/': {
      id: '/_auth/schedule/'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthScheduleIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/': {
      id: '/_auth/leagues/'
      path: '/leagues'
      fullPath: '/leagues'
      preLoaderRoute: typeof AuthLeaguesIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/invoices/': {
      id: '/_auth/invoices/'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthInvoicesIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-reviews/': {
      id: '/_auth/internal-reviews/'
      path: '/internal-reviews'
      fullPath: '/internal-reviews'
      preLoaderRoute: typeof AuthInternalReviewsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/identity-cards/': {
      id: '/_auth/identity-cards/'
      path: '/identity-cards'
      fullPath: '/identity-cards'
      preLoaderRoute: typeof AuthIdentityCardsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/documents/': {
      id: '/_auth/documents/'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthDocumentsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/balance/': {
      id: '/_auth/balance/'
      path: '/balance'
      fullPath: '/balance'
      preLoaderRoute: typeof AuthBalanceIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/availability/': {
      id: '/_auth/availability/'
      path: '/availability'
      fullPath: '/availability'
      preLoaderRoute: typeof AuthAvailabilityIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/video/$videoGroupId': {
      id: '/_auth/video/$videoGroupId'
      path: '/video/$videoGroupId'
      fullPath: '/video/$videoGroupId'
      preLoaderRoute: typeof AuthVideoVideoGroupIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/users/new': {
      id: '/_auth/users/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AuthUsersNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/users/import': {
      id: '/_auth/users/import'
      path: '/users/import'
      fullPath: '/users/import'
      preLoaderRoute: typeof AuthUsersImportLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/users/$userId': {
      id: '/_auth/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthUsersUserIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/tests/new': {
      id: '/_auth/tests/new'
      path: '/tests/new'
      fullPath: '/tests/new'
      preLoaderRoute: typeof AuthTestsNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/schedule/my': {
      id: '/_auth/schedule/my'
      path: '/schedule/my'
      fullPath: '/schedule/my'
      preLoaderRoute: typeof AuthScheduleMyLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/schedule/full': {
      id: '/_auth/schedule/full'
      path: '/schedule/full'
      fullPath: '/schedule/full'
      preLoaderRoute: typeof AuthScheduleFullLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/schedule/export': {
      id: '/_auth/schedule/export'
      path: '/schedule/export'
      fullPath: '/schedule/export'
      preLoaderRoute: typeof AuthScheduleExportLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/referee-evaluation/statistics': {
      id: '/_auth/referee-evaluation/statistics'
      path: '/referee-evaluation/statistics'
      fullPath: '/referee-evaluation/statistics'
      preLoaderRoute: typeof AuthRefereeEvaluationStatisticsLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/posts/new': {
      id: '/_auth/posts/new'
      path: '/posts/new'
      fullPath: '/posts/new'
      preLoaderRoute: typeof AuthPostsNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/new': {
      id: '/_auth/leagues/new'
      path: '/leagues/new'
      fullPath: '/leagues/new'
      preLoaderRoute: typeof AuthLeaguesNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/$leagueId': {
      id: '/_auth/leagues/$leagueId'
      path: '/leagues/$leagueId'
      fullPath: '/leagues/$leagueId'
      preLoaderRoute: typeof AuthLeaguesLeagueIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/journal/users-ranking': {
      id: '/_auth/journal/users-ranking'
      path: '/journal/users-ranking'
      fullPath: '/journal/users-ranking'
      preLoaderRoute: typeof AuthJournalUsersRankingLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/journal/ranking': {
      id: '/_auth/journal/ranking'
      path: '/journal/ranking'
      fullPath: '/journal/ranking'
      preLoaderRoute: typeof AuthJournalRankingLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/journal/my': {
      id: '/_auth/journal/my'
      path: '/journal/my'
      fullPath: '/journal/my'
      preLoaderRoute: typeof AuthJournalMyLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/journal/export': {
      id: '/_auth/journal/export'
      path: '/journal/export'
      fullPath: '/journal/export'
      preLoaderRoute: typeof AuthJournalExportLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/journal/expenses': {
      id: '/_auth/journal/expenses'
      path: '/journal/expenses'
      fullPath: '/journal/expenses'
      preLoaderRoute: typeof AuthJournalExpensesLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/journal/balance': {
      id: '/_auth/journal/balance'
      path: '/journal/balance'
      fullPath: '/journal/balance'
      preLoaderRoute: typeof AuthJournalBalanceLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/invoices/new': {
      id: '/_auth/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthInvoicesNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-videos/new': {
      id: '/_auth/internal-videos/new'
      path: '/internal-videos/new'
      fullPath: '/internal-videos/new'
      preLoaderRoute: typeof AuthInternalVideosNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-videos/my': {
      id: '/_auth/internal-videos/my'
      path: '/internal-videos/my'
      fullPath: '/internal-videos/my'
      preLoaderRoute: typeof AuthInternalVideosMyLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-videos/all': {
      id: '/_auth/internal-videos/all'
      path: '/internal-videos/all'
      fullPath: '/internal-videos/all'
      preLoaderRoute: typeof AuthInternalVideosAllLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-reviews/new': {
      id: '/_auth/internal-reviews/new'
      path: '/internal-reviews/new'
      fullPath: '/internal-reviews/new'
      preLoaderRoute: typeof AuthInternalReviewsNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-reviews/$reviewId': {
      id: '/_auth/internal-reviews/$reviewId'
      path: '/internal-reviews/$reviewId'
      fullPath: '/internal-reviews/$reviewId'
      preLoaderRoute: typeof AuthInternalReviewsReviewIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-documents/new': {
      id: '/_auth/internal-documents/new'
      path: '/internal-documents/new'
      fullPath: '/internal-documents/new'
      preLoaderRoute: typeof AuthInternalDocumentsNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-documents/my': {
      id: '/_auth/internal-documents/my'
      path: '/internal-documents/my'
      fullPath: '/internal-documents/my'
      preLoaderRoute: typeof AuthInternalDocumentsMyLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-documents/all': {
      id: '/_auth/internal-documents/all'
      path: '/internal-documents/all'
      fullPath: '/internal-documents/all'
      preLoaderRoute: typeof AuthInternalDocumentsAllLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/games/unconfirmed': {
      id: '/_auth/games/unconfirmed'
      path: '/games/unconfirmed'
      fullPath: '/games/unconfirmed'
      preLoaderRoute: typeof AuthGamesUnconfirmedLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/games/new': {
      id: '/_auth/games/new'
      path: '/games/new'
      fullPath: '/games/new'
      preLoaderRoute: typeof AuthGamesNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/games/import': {
      id: '/_auth/games/import'
      path: '/games/import'
      fullPath: '/games/import'
      preLoaderRoute: typeof AuthGamesImportLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/games/assign': {
      id: '/_auth/games/assign'
      path: '/games/assign'
      fullPath: '/games/assign'
      preLoaderRoute: typeof AuthGamesAssignLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/games/$gameId': {
      id: '/_auth/games/$gameId'
      path: '/games/$gameId'
      fullPath: '/games/$gameId'
      preLoaderRoute: typeof AuthGamesGameIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/game-documents/all': {
      id: '/_auth/game-documents/all'
      path: '/game-documents/all'
      fullPath: '/game-documents/all'
      preLoaderRoute: typeof AuthGameDocumentsAllLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/evaluation/$evaluationId': {
      id: '/_auth/evaluation/$evaluationId'
      path: '/evaluation/$evaluationId'
      fullPath: '/evaluation/$evaluationId'
      preLoaderRoute: typeof AuthEvaluationEvaluationIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/documents/$categoryId': {
      id: '/_auth/documents/$categoryId'
      path: '/documents/$categoryId'
      fullPath: '/documents/$categoryId'
      preLoaderRoute: typeof AuthDocumentsCategoryIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/balance/import': {
      id: '/_auth/balance/import'
      path: '/balance/import'
      fullPath: '/balance/import'
      preLoaderRoute: typeof AuthBalanceImportLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/availability/users-availability': {
      id: '/_auth/availability/users-availability'
      path: '/availability/users-availability'
      fullPath: '/availability/users-availability'
      preLoaderRoute: typeof AuthAvailabilityUsersAvailabilityLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/admin/reports': {
      id: '/_auth/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AuthAdminReportsLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/admin/mail-for-users': {
      id: '/_auth/admin/mail-for-users'
      path: '/admin/mail-for-users'
      fullPath: '/admin/mail-for-users'
      preLoaderRoute: typeof AuthAdminMailForUsersLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/trip-rankings/': {
      id: '/_auth/leagues/trip-rankings/'
      path: '/leagues/trip-rankings'
      fullPath: '/leagues/trip-rankings'
      preLoaderRoute: typeof AuthLeaguesTripRankingsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/league-groups/': {
      id: '/_auth/leagues/league-groups/'
      path: '/leagues/league-groups'
      fullPath: '/leagues/league-groups'
      preLoaderRoute: typeof AuthLeaguesLeagueGroupsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/categories/': {
      id: '/_auth/leagues/categories/'
      path: '/leagues/categories'
      fullPath: '/leagues/categories'
      preLoaderRoute: typeof AuthLeaguesCategoriesIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-videos/category/': {
      id: '/_auth/internal-videos/category/'
      path: '/internal-videos/category'
      fullPath: '/internal-videos/category'
      preLoaderRoute: typeof AuthInternalVideosCategoryIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/users/edit/$userId': {
      id: '/_auth/users/edit/$userId'
      path: '/users/edit/$userId'
      fullPath: '/users/edit/$userId'
      preLoaderRoute: typeof AuthUsersEditUserIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/tests/edit/$testId': {
      id: '/_auth/tests/edit/$testId'
      path: '/tests/edit/$testId'
      fullPath: '/tests/edit/$testId'
      preLoaderRoute: typeof AuthTestsEditTestIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/tests/$testId/solve': {
      id: '/_auth/tests/$testId/solve'
      path: '/tests/$testId/solve'
      fullPath: '/tests/$testId/solve'
      preLoaderRoute: typeof AuthTestsTestIdSolveLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/tests/$testId/results': {
      id: '/_auth/tests/$testId/results'
      path: '/tests/$testId/results'
      fullPath: '/tests/$testId/results'
      preLoaderRoute: typeof AuthTestsTestIdResultsLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/tests/$testId/answers': {
      id: '/_auth/tests/$testId/answers'
      path: '/tests/$testId/answers'
      fullPath: '/tests/$testId/answers'
      preLoaderRoute: typeof AuthTestsTestIdAnswersLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/posts/edit/$postId': {
      id: '/_auth/posts/edit/$postId'
      path: '/posts/edit/$postId'
      fullPath: '/posts/edit/$postId'
      preLoaderRoute: typeof AuthPostsEditPostIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/trip-rankings/new': {
      id: '/_auth/leagues/trip-rankings/new'
      path: '/leagues/trip-rankings/new'
      fullPath: '/leagues/trip-rankings/new'
      preLoaderRoute: typeof AuthLeaguesTripRankingsNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/trip-rankings/$tripRankingId': {
      id: '/_auth/leagues/trip-rankings/$tripRankingId'
      path: '/leagues/trip-rankings/$tripRankingId'
      fullPath: '/leagues/trip-rankings/$tripRankingId'
      preLoaderRoute: typeof AuthLeaguesTripRankingsTripRankingIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/league-groups/new': {
      id: '/_auth/leagues/league-groups/new'
      path: '/leagues/league-groups/new'
      fullPath: '/leagues/league-groups/new'
      preLoaderRoute: typeof AuthLeaguesLeagueGroupsNewLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/league-groups/$groupId': {
      id: '/_auth/leagues/league-groups/$groupId'
      path: '/leagues/league-groups/$groupId'
      fullPath: '/leagues/league-groups/$groupId'
      preLoaderRoute: typeof AuthLeaguesLeagueGroupsGroupIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/edit/$leagueId': {
      id: '/_auth/leagues/edit/$leagueId'
      path: '/leagues/edit/$leagueId'
      fullPath: '/leagues/edit/$leagueId'
      preLoaderRoute: typeof AuthLeaguesEditLeagueIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/journal/user/$userId': {
      id: '/_auth/journal/user/$userId'
      path: '/journal/user/$userId'
      fullPath: '/journal/user/$userId'
      preLoaderRoute: typeof AuthJournalUserUserIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-videos/edit/$videoId': {
      id: '/_auth/internal-videos/edit/$videoId'
      path: '/internal-videos/edit/$videoId'
      fullPath: '/internal-videos/edit/$videoId'
      preLoaderRoute: typeof AuthInternalVideosEditVideoIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/internal-reviews/edit/$reviewId': {
      id: '/_auth/internal-reviews/edit/$reviewId'
      path: '/internal-reviews/edit/$reviewId'
      fullPath: '/internal-reviews/edit/$reviewId'
      preLoaderRoute: typeof AuthInternalReviewsEditReviewIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/games/edit/$gameId': {
      id: '/_auth/games/edit/$gameId'
      path: '/games/edit/$gameId'
      fullPath: '/games/edit/$gameId'
      preLoaderRoute: typeof AuthGamesEditGameIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/evaluation/referee-evaluation/$gameId': {
      id: '/_auth/evaluation/referee-evaluation/$gameId'
      path: '/evaluation/referee-evaluation/$gameId'
      fullPath: '/evaluation/referee-evaluation/$gameId'
      preLoaderRoute: typeof AuthEvaluationRefereeEvaluationGameIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/evaluation/referee-evaluation-view/$evaluationId': {
      id: '/_auth/evaluation/referee-evaluation-view/$evaluationId'
      path: '/evaluation/referee-evaluation-view/$evaluationId'
      fullPath: '/evaluation/referee-evaluation-view/$evaluationId'
      preLoaderRoute: typeof AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/evaluation/edit/$gameId': {
      id: '/_auth/evaluation/edit/$gameId'
      path: '/evaluation/edit/$gameId'
      fullPath: '/evaluation/edit/$gameId'
      preLoaderRoute: typeof AuthEvaluationEditGameIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/availability/user/$userId': {
      id: '/_auth/availability/user/$userId'
      path: '/availability/user/$userId'
      fullPath: '/availability/user/$userId'
      preLoaderRoute: typeof AuthAvailabilityUserUserIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/trip-rankings/edit/$tripRankingId': {
      id: '/_auth/leagues/trip-rankings/edit/$tripRankingId'
      path: '/leagues/trip-rankings/edit/$tripRankingId'
      fullPath: '/leagues/trip-rankings/edit/$tripRankingId'
      preLoaderRoute: typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/leagues/league-groups/edit/$groupId': {
      id: '/_auth/leagues/league-groups/edit/$groupId'
      path: '/leagues/league-groups/edit/$groupId'
      fullPath: '/leagues/league-groups/edit/$groupId'
      preLoaderRoute: typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthChangePasswordLazyRoute: typeof AuthChangePasswordLazyRoute
  AuthUserProfileLazyRoute: typeof AuthUserProfileLazyRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdminMailForUsersLazyRoute: typeof AuthAdminMailForUsersLazyRoute
  AuthAdminReportsLazyRoute: typeof AuthAdminReportsLazyRoute
  AuthAvailabilityUsersAvailabilityLazyRoute: typeof AuthAvailabilityUsersAvailabilityLazyRoute
  AuthBalanceImportLazyRoute: typeof AuthBalanceImportLazyRoute
  AuthDocumentsCategoryIdLazyRoute: typeof AuthDocumentsCategoryIdLazyRoute
  AuthEvaluationEvaluationIdLazyRoute: typeof AuthEvaluationEvaluationIdLazyRoute
  AuthGameDocumentsAllLazyRoute: typeof AuthGameDocumentsAllLazyRoute
  AuthGamesGameIdLazyRoute: typeof AuthGamesGameIdLazyRoute
  AuthGamesAssignLazyRoute: typeof AuthGamesAssignLazyRoute
  AuthGamesImportLazyRoute: typeof AuthGamesImportLazyRoute
  AuthGamesNewLazyRoute: typeof AuthGamesNewLazyRoute
  AuthGamesUnconfirmedLazyRoute: typeof AuthGamesUnconfirmedLazyRoute
  AuthInternalDocumentsAllLazyRoute: typeof AuthInternalDocumentsAllLazyRoute
  AuthInternalDocumentsMyLazyRoute: typeof AuthInternalDocumentsMyLazyRoute
  AuthInternalDocumentsNewLazyRoute: typeof AuthInternalDocumentsNewLazyRoute
  AuthInternalReviewsReviewIdLazyRoute: typeof AuthInternalReviewsReviewIdLazyRoute
  AuthInternalReviewsNewLazyRoute: typeof AuthInternalReviewsNewLazyRoute
  AuthInternalVideosAllLazyRoute: typeof AuthInternalVideosAllLazyRoute
  AuthInternalVideosMyLazyRoute: typeof AuthInternalVideosMyLazyRoute
  AuthInternalVideosNewLazyRoute: typeof AuthInternalVideosNewLazyRoute
  AuthInvoicesNewLazyRoute: typeof AuthInvoicesNewLazyRoute
  AuthJournalBalanceLazyRoute: typeof AuthJournalBalanceLazyRoute
  AuthJournalExpensesLazyRoute: typeof AuthJournalExpensesLazyRoute
  AuthJournalExportLazyRoute: typeof AuthJournalExportLazyRoute
  AuthJournalMyLazyRoute: typeof AuthJournalMyLazyRoute
  AuthJournalRankingLazyRoute: typeof AuthJournalRankingLazyRoute
  AuthJournalUsersRankingLazyRoute: typeof AuthJournalUsersRankingLazyRoute
  AuthLeaguesLeagueIdLazyRoute: typeof AuthLeaguesLeagueIdLazyRoute
  AuthLeaguesNewLazyRoute: typeof AuthLeaguesNewLazyRoute
  AuthPostsNewLazyRoute: typeof AuthPostsNewLazyRoute
  AuthRefereeEvaluationStatisticsLazyRoute: typeof AuthRefereeEvaluationStatisticsLazyRoute
  AuthScheduleExportLazyRoute: typeof AuthScheduleExportLazyRoute
  AuthScheduleFullLazyRoute: typeof AuthScheduleFullLazyRoute
  AuthScheduleMyLazyRoute: typeof AuthScheduleMyLazyRoute
  AuthTestsNewLazyRoute: typeof AuthTestsNewLazyRoute
  AuthUsersUserIdLazyRoute: typeof AuthUsersUserIdLazyRoute
  AuthUsersImportLazyRoute: typeof AuthUsersImportLazyRoute
  AuthUsersNewLazyRoute: typeof AuthUsersNewLazyRoute
  AuthVideoVideoGroupIdLazyRoute: typeof AuthVideoVideoGroupIdLazyRoute
  AuthAvailabilityIndexLazyRoute: typeof AuthAvailabilityIndexLazyRoute
  AuthBalanceIndexLazyRoute: typeof AuthBalanceIndexLazyRoute
  AuthDocumentsIndexLazyRoute: typeof AuthDocumentsIndexLazyRoute
  AuthIdentityCardsIndexLazyRoute: typeof AuthIdentityCardsIndexLazyRoute
  AuthInternalReviewsIndexLazyRoute: typeof AuthInternalReviewsIndexLazyRoute
  AuthInvoicesIndexLazyRoute: typeof AuthInvoicesIndexLazyRoute
  AuthLeaguesIndexLazyRoute: typeof AuthLeaguesIndexLazyRoute
  AuthScheduleIndexLazyRoute: typeof AuthScheduleIndexLazyRoute
  AuthTestsIndexLazyRoute: typeof AuthTestsIndexLazyRoute
  AuthUsersIndexLazyRoute: typeof AuthUsersIndexLazyRoute
  AuthVideoIndexLazyRoute: typeof AuthVideoIndexLazyRoute
  AuthAvailabilityUserUserIdLazyRoute: typeof AuthAvailabilityUserUserIdLazyRoute
  AuthEvaluationEditGameIdLazyRoute: typeof AuthEvaluationEditGameIdLazyRoute
  AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRoute: typeof AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRoute
  AuthEvaluationRefereeEvaluationGameIdLazyRoute: typeof AuthEvaluationRefereeEvaluationGameIdLazyRoute
  AuthGamesEditGameIdLazyRoute: typeof AuthGamesEditGameIdLazyRoute
  AuthInternalReviewsEditReviewIdLazyRoute: typeof AuthInternalReviewsEditReviewIdLazyRoute
  AuthInternalVideosEditVideoIdLazyRoute: typeof AuthInternalVideosEditVideoIdLazyRoute
  AuthJournalUserUserIdLazyRoute: typeof AuthJournalUserUserIdLazyRoute
  AuthLeaguesEditLeagueIdLazyRoute: typeof AuthLeaguesEditLeagueIdLazyRoute
  AuthLeaguesLeagueGroupsGroupIdLazyRoute: typeof AuthLeaguesLeagueGroupsGroupIdLazyRoute
  AuthLeaguesLeagueGroupsNewLazyRoute: typeof AuthLeaguesLeagueGroupsNewLazyRoute
  AuthLeaguesTripRankingsTripRankingIdLazyRoute: typeof AuthLeaguesTripRankingsTripRankingIdLazyRoute
  AuthLeaguesTripRankingsNewLazyRoute: typeof AuthLeaguesTripRankingsNewLazyRoute
  AuthPostsEditPostIdLazyRoute: typeof AuthPostsEditPostIdLazyRoute
  AuthTestsTestIdAnswersLazyRoute: typeof AuthTestsTestIdAnswersLazyRoute
  AuthTestsTestIdResultsLazyRoute: typeof AuthTestsTestIdResultsLazyRoute
  AuthTestsTestIdSolveLazyRoute: typeof AuthTestsTestIdSolveLazyRoute
  AuthTestsEditTestIdLazyRoute: typeof AuthTestsEditTestIdLazyRoute
  AuthUsersEditUserIdLazyRoute: typeof AuthUsersEditUserIdLazyRoute
  AuthInternalVideosCategoryIndexLazyRoute: typeof AuthInternalVideosCategoryIndexLazyRoute
  AuthLeaguesCategoriesIndexLazyRoute: typeof AuthLeaguesCategoriesIndexLazyRoute
  AuthLeaguesLeagueGroupsIndexLazyRoute: typeof AuthLeaguesLeagueGroupsIndexLazyRoute
  AuthLeaguesTripRankingsIndexLazyRoute: typeof AuthLeaguesTripRankingsIndexLazyRoute
  AuthLeaguesLeagueGroupsEditGroupIdLazyRoute: typeof AuthLeaguesLeagueGroupsEditGroupIdLazyRoute
  AuthLeaguesTripRankingsEditTripRankingIdLazyRoute: typeof AuthLeaguesTripRankingsEditTripRankingIdLazyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthChangePasswordLazyRoute: AuthChangePasswordLazyRoute,
  AuthUserProfileLazyRoute: AuthUserProfileLazyRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAdminMailForUsersLazyRoute: AuthAdminMailForUsersLazyRoute,
  AuthAdminReportsLazyRoute: AuthAdminReportsLazyRoute,
  AuthAvailabilityUsersAvailabilityLazyRoute:
    AuthAvailabilityUsersAvailabilityLazyRoute,
  AuthBalanceImportLazyRoute: AuthBalanceImportLazyRoute,
  AuthDocumentsCategoryIdLazyRoute: AuthDocumentsCategoryIdLazyRoute,
  AuthEvaluationEvaluationIdLazyRoute: AuthEvaluationEvaluationIdLazyRoute,
  AuthGameDocumentsAllLazyRoute: AuthGameDocumentsAllLazyRoute,
  AuthGamesGameIdLazyRoute: AuthGamesGameIdLazyRoute,
  AuthGamesAssignLazyRoute: AuthGamesAssignLazyRoute,
  AuthGamesImportLazyRoute: AuthGamesImportLazyRoute,
  AuthGamesNewLazyRoute: AuthGamesNewLazyRoute,
  AuthGamesUnconfirmedLazyRoute: AuthGamesUnconfirmedLazyRoute,
  AuthInternalDocumentsAllLazyRoute: AuthInternalDocumentsAllLazyRoute,
  AuthInternalDocumentsMyLazyRoute: AuthInternalDocumentsMyLazyRoute,
  AuthInternalDocumentsNewLazyRoute: AuthInternalDocumentsNewLazyRoute,
  AuthInternalReviewsReviewIdLazyRoute: AuthInternalReviewsReviewIdLazyRoute,
  AuthInternalReviewsNewLazyRoute: AuthInternalReviewsNewLazyRoute,
  AuthInternalVideosAllLazyRoute: AuthInternalVideosAllLazyRoute,
  AuthInternalVideosMyLazyRoute: AuthInternalVideosMyLazyRoute,
  AuthInternalVideosNewLazyRoute: AuthInternalVideosNewLazyRoute,
  AuthInvoicesNewLazyRoute: AuthInvoicesNewLazyRoute,
  AuthJournalBalanceLazyRoute: AuthJournalBalanceLazyRoute,
  AuthJournalExpensesLazyRoute: AuthJournalExpensesLazyRoute,
  AuthJournalExportLazyRoute: AuthJournalExportLazyRoute,
  AuthJournalMyLazyRoute: AuthJournalMyLazyRoute,
  AuthJournalRankingLazyRoute: AuthJournalRankingLazyRoute,
  AuthJournalUsersRankingLazyRoute: AuthJournalUsersRankingLazyRoute,
  AuthLeaguesLeagueIdLazyRoute: AuthLeaguesLeagueIdLazyRoute,
  AuthLeaguesNewLazyRoute: AuthLeaguesNewLazyRoute,
  AuthPostsNewLazyRoute: AuthPostsNewLazyRoute,
  AuthRefereeEvaluationStatisticsLazyRoute:
    AuthRefereeEvaluationStatisticsLazyRoute,
  AuthScheduleExportLazyRoute: AuthScheduleExportLazyRoute,
  AuthScheduleFullLazyRoute: AuthScheduleFullLazyRoute,
  AuthScheduleMyLazyRoute: AuthScheduleMyLazyRoute,
  AuthTestsNewLazyRoute: AuthTestsNewLazyRoute,
  AuthUsersUserIdLazyRoute: AuthUsersUserIdLazyRoute,
  AuthUsersImportLazyRoute: AuthUsersImportLazyRoute,
  AuthUsersNewLazyRoute: AuthUsersNewLazyRoute,
  AuthVideoVideoGroupIdLazyRoute: AuthVideoVideoGroupIdLazyRoute,
  AuthAvailabilityIndexLazyRoute: AuthAvailabilityIndexLazyRoute,
  AuthBalanceIndexLazyRoute: AuthBalanceIndexLazyRoute,
  AuthDocumentsIndexLazyRoute: AuthDocumentsIndexLazyRoute,
  AuthIdentityCardsIndexLazyRoute: AuthIdentityCardsIndexLazyRoute,
  AuthInternalReviewsIndexLazyRoute: AuthInternalReviewsIndexLazyRoute,
  AuthInvoicesIndexLazyRoute: AuthInvoicesIndexLazyRoute,
  AuthLeaguesIndexLazyRoute: AuthLeaguesIndexLazyRoute,
  AuthScheduleIndexLazyRoute: AuthScheduleIndexLazyRoute,
  AuthTestsIndexLazyRoute: AuthTestsIndexLazyRoute,
  AuthUsersIndexLazyRoute: AuthUsersIndexLazyRoute,
  AuthVideoIndexLazyRoute: AuthVideoIndexLazyRoute,
  AuthAvailabilityUserUserIdLazyRoute: AuthAvailabilityUserUserIdLazyRoute,
  AuthEvaluationEditGameIdLazyRoute: AuthEvaluationEditGameIdLazyRoute,
  AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRoute:
    AuthEvaluationRefereeEvaluationViewEvaluationIdLazyRoute,
  AuthEvaluationRefereeEvaluationGameIdLazyRoute:
    AuthEvaluationRefereeEvaluationGameIdLazyRoute,
  AuthGamesEditGameIdLazyRoute: AuthGamesEditGameIdLazyRoute,
  AuthInternalReviewsEditReviewIdLazyRoute:
    AuthInternalReviewsEditReviewIdLazyRoute,
  AuthInternalVideosEditVideoIdLazyRoute:
    AuthInternalVideosEditVideoIdLazyRoute,
  AuthJournalUserUserIdLazyRoute: AuthJournalUserUserIdLazyRoute,
  AuthLeaguesEditLeagueIdLazyRoute: AuthLeaguesEditLeagueIdLazyRoute,
  AuthLeaguesLeagueGroupsGroupIdLazyRoute:
    AuthLeaguesLeagueGroupsGroupIdLazyRoute,
  AuthLeaguesLeagueGroupsNewLazyRoute: AuthLeaguesLeagueGroupsNewLazyRoute,
  AuthLeaguesTripRankingsTripRankingIdLazyRoute:
    AuthLeaguesTripRankingsTripRankingIdLazyRoute,
  AuthLeaguesTripRankingsNewLazyRoute: AuthLeaguesTripRankingsNewLazyRoute,
  AuthPostsEditPostIdLazyRoute: AuthPostsEditPostIdLazyRoute,
  AuthTestsTestIdAnswersLazyRoute: AuthTestsTestIdAnswersLazyRoute,
  AuthTestsTestIdResultsLazyRoute: AuthTestsTestIdResultsLazyRoute,
  AuthTestsTestIdSolveLazyRoute: AuthTestsTestIdSolveLazyRoute,
  AuthTestsEditTestIdLazyRoute: AuthTestsEditTestIdLazyRoute,
  AuthUsersEditUserIdLazyRoute: AuthUsersEditUserIdLazyRoute,
  AuthInternalVideosCategoryIndexLazyRoute:
    AuthInternalVideosCategoryIndexLazyRoute,
  AuthLeaguesCategoriesIndexLazyRoute: AuthLeaguesCategoriesIndexLazyRoute,
  AuthLeaguesLeagueGroupsIndexLazyRoute: AuthLeaguesLeagueGroupsIndexLazyRoute,
  AuthLeaguesTripRankingsIndexLazyRoute: AuthLeaguesTripRankingsIndexLazyRoute,
  AuthLeaguesLeagueGroupsEditGroupIdLazyRoute:
    AuthLeaguesLeagueGroupsEditGroupIdLazyRoute,
  AuthLeaguesTripRankingsEditTripRankingIdLazyRoute:
    AuthLeaguesTripRankingsEditTripRankingIdLazyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
